document.addEventListener('DOMContentLoaded', () => {
    const uploadPhotoBlockList = document.querySelectorAll('.js-upload-photo');

    if (uploadPhotoBlockList.length) {
        uploadPhotoBlockList.forEach(block => {
            const buttonList = block.querySelectorAll('.js-upload-photo-btn');
            const input = block.querySelector('input[type="file"]');
            const imageBlock = block.querySelector('.wcl-image-wrapper img');

            // Search image wrapper in account details
            const sidebarImageBlock = document.querySelector('.wcl-modal-sidebar__avatar img');

            if (buttonList.length && input) {
                buttonList.forEach(button => {
                    button.addEventListener('click', e => {
                        e.preventDefault();

                        input.click();
                    });

                });

                input.addEventListener('change', e => {
                    const file = e.target.files[0];

                    if (file.size > 3100000) {
                        alert(multilanguage_object["Image size exceeds 3.1MB"]);
                        return;
                    }

                    const fileType = file['type'];

                    const validImageTypes = ['image/png', 'image/jpeg', 'image/gif'];

                    if (!validImageTypes.includes(fileType)) {
                        alert(multilanguage_object["The image must be in valid formats (gif, jpg, jpeg, png)"]);
                        return;
                    }

                    // Convert image into base64 using FileReader JS class
                    const reader = new FileReader();

                    // When the image is converted (loaded) we show a preview block
                    reader.readAsDataURL(file);
                    reader.onload = () => {
                        imageBlock.src = reader.result;

                        sidebarImageBlock && (sidebarImageBlock.src = reader.result);
                    };
                })
            }
        });
    }
});